import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CONSENT_KEY = "kive_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        // Small delay so it doesn't appear immediately on load
        const timer = setTimeout(() => setVisible(true), 1200);
        return () => clearTimeout(timer);
      }
    } catch {
      // localStorage unavailable — assume no consent
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify({ accepted: true, date: new Date().toISOString() }));
    } catch {
      // Storage unavailable
    }
    setVisible(false);
    setDismissed(true);
  };

  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
  };

  if (!visible || dismissed) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={t("cookieConsent.label")}
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0d1b2a] border-t border-white/10 shadow-2xl"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-white/80 text-sm leading-relaxed">
            {t("cookieConsent.message")}
            <Link
              to="/privacy-policy"
              className="text-[#c8881a] hover:text-[#e8a020] underline underline-offset-2 ml-1 transition-colors whitespace-nowrap"
            >
              {t("cookieConsent.learnMore")}
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleDismiss}
            className="text-white/50 hover:text-white text-sm font-medium transition-colors cursor-pointer whitespace-nowrap px-2 py-1"
            aria-label={t("cookieConsent.dismiss")}
          >
            {t("cookieConsent.dismiss")}
          </button>
          <button
            onClick={handleAccept}
            className="px-5 py-2.5 bg-[#c8881a] text-white text-sm font-semibold rounded-sm hover:bg-[#e8a020] transition-colors cursor-pointer whitespace-nowrap"
          >
            {t("cookieConsent.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}